module.exports = __webpack_public_path__ + "img/ai-img-douyin.e4decb42.png";